<template>
    <div>
        <div class="-companies">
            <div class="search-area">
                <div class="search-row f -a-center">
                    <div class="form-group expand">
                        <label for="clients-search"
                               class="sr-only">
                            Chercher un membre
                        </label>
                        <div class="input-group">
                            <div class="input-group-addon">
                                <loader v-show="loading"></loader>
                                <i v-show="!loading" class="glyphicon glyphicon-search"></i>
                            </div>
                            <input type="text"
                                   class="form-control"
                                   id="clients-search"
                                   v-model="searchQuery"
                                   placeholder="Chercher un nom, un numéro de téléphone, etc">
                        </div>
                    </div>
                    <a href="#"
                       v-on:click.prevent="downloadExcel"
                       class="btn btn-default">
                        <span v-show="!generatingExcel">.xlsx</span>
                        <loader v-show="generatingExcel"></loader>
                    </a>
                </div>
            </div>

            <div>
                <table class="table table-hover -clients -row-links">
                    <tr>
                        <th>Référence</th>
                        <th>Produit</th>
                        <th>Contact</th>
                        <th>Capital</th>
                        <th>Versement</th>
                    </tr>

                    <tr v-for="contract in contracts" class="row-company">
                        <td class="table-col">
                            <a href="" v-link="{name: 'contracts-edit',
                                params: {id: contract.client.id, contractId:
                               contract.id }}">
                            {{contract.number}}
                            </a>
                        </td>
                        <td class="table-col">
                            {{contract.type.name}}
                        </td>
                        <td class="table-col">
                            <a href="#" v-link="{name: 'clients-detail',
                            params: {id: contract.client.id}}">
                               {{contract.client.name}}
                            </a>
                        </td>
                        <td class="table-col">
                            <a href="" v-link="{name: 'contracts-edit',
                                params: {id: contract.client.id, contractId:
                               contract.id }}">
                                {{{contract.wire_initial | money 2}}}
                            </a>
                        </td>
                        <td class="table-col">
                            <a href="" v-link="{name: 'contracts-edit',
                                params: {id: contract.client.id, contractId:
                               contract.id }}">
                                {{{contract.wire_monthly | money 2}}}
                            </a>
                        </td>
                    </tr>
                </table>
                <loader v-show="loading" class="bigger-loader"></loader>

                <div class="load-more text-center">
                    <a href="#"
                       v-if="hasNext && !loading"
                       v-on:click.prevent="updateList(true)"
                       class="btn btn-default">
                        Charger plus
                    </a>
                </div>
            </div>

        </div>
    </div>

</template>

<style lang="less" type="text/less" scoped>
    @import '~src/style/variables';
    @import (reference) '~bootstrap/less/mixins/vendor-prefixes';
    @import (reference) '~bootstrap/less/mixins/tab-focus';
    @import (reference) '~bootstrap/less/mixins/opacity';
    @import (reference) '~bootstrap/less/mixins/buttons';
    @import (reference) '~bootstrap/less/buttons';
    .search-area {
        margin-bottom: @grid-gutter-width;
    }

    .search-row .form-group {
        flex-basis: 0;
        margin: 0;
        margin-right: @grid-gutter-width;
    }
</style>

<script>
    import {listPage} from '../../api/contract';
    import {asyncDebounce, makeUpdateList} from '../../utils';
    import Loader from '../../components/Loader';
    import {downloadUrl} from '../../api/contract';

    export default {
        components: {
            Loader
        },
        name: 'contracts-tab',
        props: {
            company: Object
        },
        data() {
            return {
                page: 0,
                hasNext: false,
                loading: false,
                generatingExcel: false,
                searchQuery: '',
                contracts: []
            };
        },
        watch: {
            searchQuery() {
                this.page = 0;
                this.updateList();
            }
        },
        methods: {
            /**
             * update the list of contract and manage pagination and loading
             */
            updateList: makeUpdateList({
                loading: 'loading',
                page: 'page',
                hasNext: 'hasNext',
                list: 'contracts',
                fetch: async function (page) {
                    return await listPage(
                        null,
                        page,
                        this.company.id,
                        this.searchQuery
                    );
                }
            }),
            /**
             * When user click on the ".xlsx" button, call the api and
             * download an excel file.
             */
            downloadExcel: asyncDebounce(async function () {
                this.generatingExcel = true;

                const url = (await downloadUrl(
                    null,
                    this.company.id,
                    this.searchQuery,
                )).url;
                const iframe = document.createElement('IFRAME');
                iframe.setAttribute('src', url);
                iframe.style.display = 'none';
                document.body.appendChild(iframe);

                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 10000);

                this.generatingExcel = false;
            })
        },
        ready() {
            this.updateList();
        }
    };
</script>



// WEBPACK FOOTER //
// ContractsTab.vue?4994e75c